import React from "react";
import TimeAgo from "react-timeago";
import StaffProfile from "../../Staff/partials/StaffProfileCard";

const LogList = ({ list, onView }) => {
	return (
		<>
			<div className="table-scrollable">
				{list && (
					<table className="table table-inbox table-hover table-bordered">
						<thead>
							<tr>
								<th className="text-center">sn</th>
								<th> Performed By </th>
								<th> Action Performed </th>

								<th> Created</th>
								<th className="text-center">View</th>
							</tr>
						</thead>
						<tbody>
							{list.map((p, index) => (
								<tr
									key={index}
									className="odd gradeX text-left"
								>
									<td className="text-center">
										<strong>{index + 1}</strong>
									</td>

									<td className="table-patient-display">
										<StaffProfile item={p.staff} />
									</td>

									<td>{p.activity}</td>

									<td>
										<TimeAgo
											date={new Date(
												parseInt(p.datetime)
											).toLocaleDateString()}
										/>
									</td>

									<td className="text-center">
										<button
											title="View"
											className="btn btn-tbl-edit btn-xs text-primary"
											onClick={() => onView(p)}
										>
											<i className="fa fa-home"></i>
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				)}
			</div>
		</>
	);
};
export default LogList;
